<div class="resset-dialog alt-justify-center">
  <h2 *ngIf="statusDetail =='error'"> {{"AUTH.mail-notsended" | translate}} </h2>

  <h2 *ngIf="statusDetail =='success'"> {{"AUTH.passrst-done" | translate}} </h2>
  <p *ngIf="statusDetail =='success'">{{"AUTH.redirect-login" | translate}}</p>
</div>
